import StoreLocator from './pages/storeLocator/storeLocator';
import StoreBookingOnLanding from './pages/storeLocator/storeBookingOnLanding';

document.addEventListener('DOMContentLoaded', (e) => {
  new StoreLocator().init();

  // Open the booking modal on landing, if requested
  new StoreBookingOnLanding().init();
});
